import { Tag, TopicType } from '../../../ontology.model';

export const standardFormTags: Tag[] = [
  {
    id: 'tag.sf',
    name: 'Standard Form',
    parent_id: 'tag.num',
    topic_type: TopicType.Structural,
    prerequisite_tag_ids: [],
    icon: 'superscript',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.sf.transform',
    name: 'Transformations',
    parent_id: 'tag.sf',
    topic_type: TopicType.Structural,
    icon: 'arrows-rotate',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.sf.ops',
    name: 'Arithmetic Operations',
    parent_id: 'tag.sf',
    topic_type: TopicType.Foundational,
    icon: 'plus-minus',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
];
